import CryptoJS from 'crypto-js';

/**
 * Client-side key used only for obfuscating non-sensitive data in
 * localStorage (e.g. remembered email). This is NOT a security
 * boundary — it prevents casual inspection only.
 */
export const CLIENT_OBFUSCATION_KEY = 'nsight-client-obfuscation-v1';

export const encryptData = (data: string, key: string): string => {
  return CryptoJS.AES.encrypt(data, key).toString();
};

export const decryptData = (encryptedData: string, key: string): string => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};
